import { IServiceClientFilterValues } from './types';

export const getDefaultServiceClientFilters = (): IServiceClientFilterValues => ({
    page: 0,
    limit: 50,
    store: [],
    make: [],
    name: '',
    email: '',
    phone: '',
    vehicle: [],
    assigned: [],
    assignment: '',
    createdAt: null,
    isSearching: false,
    isQueryEnabled: false,
    query: '',
    isTabsEnabled: false,
    tabValue: '',
});
